import emptySchemaCollection from '../validation/schema-collection';
import cartSchemas from './cart.schema';
import checkoutSchemas from './checkout.schema';
import elementSchemas from './element.schema';
import fileSchemas from './file.schema';
import formSchemas from './form.schema';
import frameSchemas from './frame.schema';
import itemListSchemas from './item-list.schema';
import learningFeedbackSchemas from './learning-feedback.schema';
import linkSchemas from './link.schema';
import orderSchemas from './order.schema';
import productSchemas from './product.schema';

export default emptySchemaCollection
  .addSchemas('exitLink', linkSchemas)
  .addSchemas('element', elementSchemas)
  .addSchemas('file', fileSchemas)
  .addSchemas('frame', frameSchemas)
  .addSchemas('itemList', itemListSchemas)
  .addSchemas('learningFeedback', learningFeedbackSchemas)
  .addSchemas('order', orderSchemas)
  .addSchemas('product', productSchemas)
  .addSchemas('cart', cartSchemas)
  .addSchemas('checkout', checkoutSchemas)
  .addSchemas('form', formSchemas);
